// ════════════════════════════════════════════════════════════════════════════
//  Confirmação antes de transmitir uma NF-e à SEFAZ.
//  Diz em qual AMBIENTE a nota vai sair: em produção a nota tem valor fiscal e
//  só se desfaz cancelando; em homologação ela não vale — e emitir "de teste"
//  achando que era de verdade é o engano que esta pergunta evita.
// ════════════════════════════════════════════════════════════════════════════

import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface Props {
  open: boolean;
  producao: boolean;
  /** Pontos a conferir antes de enviar. Não bloqueiam: a SEFAZ aceita, mas costumam ser engano. */
  avisos?: string[];
  onConfirmar: () => void;
  onFechar: () => void;
}

/** Valor de frete com a modalidade "9 - Sem frete": a nota diz que há frete e que não há transporte. */
export function avisoFreteSemTransporte(valorFrete: number, tipoFrete: number): string | null {
  if (!(valorFrete > 0) || tipoFrete !== 9) return null;
  const valor = valorFrete.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `A nota tem valor de frete (R$ ${valor}), mas o frete está como "Sem frete". Confira a modalidade do frete ou zere o valor.`;
}

export function ConfirmarTransmissaoDialog({ open, producao, avisos, onConfirmar, onFechar }: Props) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o) onFechar(); }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {producao ? 'Transmitir em PRODUÇÃO?' : 'Transmitir em HOMOLOGAÇÃO?'}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {producao
              ? 'A nota será enviada à SEFAZ com valor fiscal. Depois de autorizada, só pode ser desfeita por cancelamento.'
              : 'A nota será enviada ao ambiente de testes da SEFAZ e NÃO tem valor fiscal. Para emitir de verdade, edite a nota e ligue "Produção" antes de transmitir.'}
          </AlertDialogDescription>
          {avisos && avisos.length > 0 && (
            <div className="rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100">
              <p className="font-medium">Confira antes de enviar:</p>
              <ul className="mt-1 list-disc space-y-1 pl-5">
                {avisos.map((a) => <li key={a}>{a}</li>)}
              </ul>
            </div>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Voltar</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirmar}>
            {producao ? 'Transmitir em produção' : 'Transmitir em homologação'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
